import {
    Directive,
    Input,
    OnInit,
    ViewContainerRef,
    inject,
} from '@angular/core';
import {
    InjectionHostLocation,
    InjectionService,
} from '../services/injection.service';

@Directive({
    selector: '[pfHost]',
    standalone: false,
})
export class InjectionHostDirective implements OnInit {
    viewContainerRef = inject(ViewContainerRef);
    private injectionService = inject(InjectionService);

    @Input() pfHost: InjectionHostLocation = 'local';
    ngOnInit(): void {
        if (this.pfHost === 'local') {
            return;
        }
        this.injectionService.setViewContainerRef(
            this.pfHost,
            this.viewContainerRef
        );
    }
}
